import httpClient from '../config/httpClient';
import {
  subscribeToIntegrationImportLogs,
  getIntegrationImportLogDetails,
  subscribeToIntegrationStatus,
} from './integrationImport';

export const getZohoPeopleAuthUrl = async (companyId, userId) => {
  const { data } = await httpClient.post('/zohoPeopleGetAuthUrl', {
    companyId,
    userId,
  });
  return data;
};

export const disconnectZohoPeople = async (companyId, userId) => {
  const { data } = await httpClient.post('/zohoPeopleDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getZohoPeopleEmployees = async (companyId) => {
  const { data } = await httpClient.post('/zohoPeopleGetEmployees', {
    companyId,
  });
  return data;
};

export const autoMapZohoPeopleEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/zohoPeopleAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const saveZohoPeopleMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/zohoPeopleSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncZohoPeopleTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/zohoPeopleSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const exportAllZohoPeopleEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/zohoPeopleExportAllEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const previewZohoPeopleImport = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/zohoPeoplePreviewImport', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const importZohoPeopleEmployees = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/zohoPeopleImportEmployees', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const subscribeToZohoPeopleImportLogs = (companyId, onUpdate) =>
  subscribeToIntegrationImportLogs(companyId, 'zohoPeople', onUpdate);

export const getZohoPeopleImportLogDetails = (companyId, logId) =>
  getIntegrationImportLogDetails(companyId, 'zohoPeople', logId);

const DISCONNECTED_ZOHO_STATUS = {
  connected: false,
  connectedAt: null,
  connectedBy: null,
  employeeMappings: {},
  employeeMappingsUpdatedAt: null,
  lastSyncAt: null,
  lastSyncStats: null,
};

export const subscribeToZohoPeopleStatus = (companyId, onUpdate) => {
  return subscribeToIntegrationStatus(
    companyId,
    'zohoPeople',
    ({ exists, data: d }) => {
      if (!exists || !d.connected) {
        onUpdate(DISCONNECTED_ZOHO_STATUS);
        return;
      }
      onUpdate({
        connected: true,
        connectedAt: d.connectedAt ? new Date(d.connectedAt) : null,
        connectedBy: d.connectedBy || null,
        employeeMappings: d.employeeMappings || {},
        employeeMappingsUpdatedAt: d.employeeMappingsUpdatedAt
          ? new Date(d.employeeMappingsUpdatedAt)
          : null,
        lastSyncAt: d.lastSyncAt ? new Date(d.lastSyncAt) : null,
        lastSyncStats: d.lastSyncStats || null,
      });
    }
  );
};
